import React from "react";
import { capitalize } from 'lodash';
import GroupMembers from "../group-members";
import GroupsApps from "../group-apps";
import GroupsLayers from "../group-layers";
import GroupsProjects from "../group-projects";
import { Resource } from '../../models/group';
import { useChangePermissionsMutation, useGetGroupQuery, useGetGroupMembersQuery } from '../../services/groups.service';

export function formatResourceButtonName(resource: Resource): string {
  const parsedResource = capitalize(resource);
  return `Add ${parsedResource}`.toUpperCase();
}

const groupTabs = (id: string) => {
  const { data: group } = useGetGroupQuery({ id });

  return [
    {
      label: 'Members',
      tabPanelComponent: <GroupMembers groupId={id} />,
      actionButtonLabel: formatResourceButtonName(Resource.Members),
      disabledActionButtonTooltip: 'managed via your company\'s identity provider',
      isEditable: !group?.isManaged
    },
    {
      label: 'Apps',
      tabPanelComponent: <GroupsApps groupId={id} />,
      actionButtonLabel: formatResourceButtonName(Resource.Apps)
    },
    {
      label: 'Map Layers',
      tabPanelComponent: <GroupsLayers groupId={id} />,
      actionButtonLabel: formatResourceButtonName(Resource.Layers)
    },
    {
      label: 'Projects',
      tabPanelComponent: <GroupsProjects groupId={id} />,
      actionButtonLabel: formatResourceButtonName(Resource.Projects)
    },
  ];
}

export default groupTabs;
